import {required, requiredIf, minValue, maxValue} from 'vuelidate/lib/validators';

const requiredIfFellowMIGSSurgeon = requiredIf((vm) => {
  return vm.MIGSSurgeon === 1 && (!vm.MIGSSurgeonPSGE && !vm.MIGSSurgeonPSRM);
});

const requiredIfFellowMIGSAssist = requiredIf((vm) => {
  return vm.MIGSAssist === 1 && (!vm.MIGSAssistPSGE && !vm.MIGSAssistPSRM);
});

export default {
  MIGSSurgeon: {
    required
  },
  MIGSSurgeonPSGE: {
    requiredIf: requiredIfFellowMIGSSurgeon
  },
  MIGSSurgeonPSRM: {
    requiredIf: requiredIfFellowMIGSSurgeon
  },
  MIGSAssist: {
    required
  },
  MIGSAssistPSGE: {
    requiredIf: requiredIfFellowMIGSAssist
  },
  MIGSAssistPSRM: {
    requiredIf: requiredIfFellowMIGSAssist
  },
}
